import React from 'react'

function NotRequired(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      fill="none"
      {...props}
    >
      <circle cx={13} cy={13} r={13} fill="#78787B" />
      <path
        fill="#fff"
        d="m20.436 16.815-.492-1.616h-2.475l-.492 1.616h-1.55L17.822 10h1.76l2.404 6.815h-1.55Zm-.836-2.823a1346.28 1346.28 0 0 1-.77-2.483 7.858 7.858 0 0 1-.121-.455c-.102.396-.395 1.376-.878 2.938h1.77ZM15.57 10.027l-2.53 6.787h-1.285l2.53-6.787h1.286ZM11.021 16.814H9.192L6.24 11.68h-.042c.059.907.088 1.554.088 1.94v3.194H5v-6.787h1.815l2.948 5.084h.033a41.164 41.164 0 0 1-.07-1.871v-3.213h1.295v6.787Z"
      />
    </svg>
  )
}
export default NotRequired
